define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/getProto.js
 ** module id = 696
 ** module chunks = 0
 **/